import React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import * as userColumnVisibilitiesActions from 'actions/userColumnVisibilitiesActions';
import { getDefinitionForWorkflow } from 'selectors/jobTableDefinitionSelector';
import { HeaderDropDown } from 'components/layout';
import Checkbubble, { CHECKBUBLE_SIZE_SMALL } from 'components/common/Checkbubble';

import './styles.css';

class TableColumnsDropDown extends React.Component {
  /*handleItemClick(column) {
    console.log('clicked',column)
    //const { match, actions,params } = this.props;
     const { actions, params: state } = this.props; 
    //var state = (match && match.params && match.params.state) ? match.params.state : 'new';
    //var state = params ?params : 'new';
    console.log('clickedState',state)
    actions.setUserColumnVisibility(
      //params.state,
      state,
      column.key,
      !column.visible
    );
  }*/
handleItemClick(column) {
   const { actions, params } = this.props;
  const rawState = params || 'new'; // get the raw state from URL
  const state = rawState.replace('-', ' '); // normalize state


  actions.setUserColumnVisibility(
    state, // pass normalized state
    column.key,
    !column.visible
  );
}



  handleResetItemClick() {
    const { actions,params } = this.props;
    const workflowState = params.replace('-', ' ');
    actions.deleteUserColumnVisibilities(workflowState);
  }

  handleCheckboxClick(e) {
    e.stopPropagation();
  }

  handleClose() {
    const {actions,params } = this.props;
    const workflowState = params?params.replace('-', ' '):null;
    actions.saveUserColumnVisibilities(workflowState);
  }

  render() {
    const { jobTableDefinition } = this.props;
    return (
      <HeaderDropDown
        className="table-columns-drop-down"
        ligature="more_horiz"
        onClose={this.handleClose.bind(this)}
      >
        <div
          className="table-columns-drop-down-item"
          onClick={this.handleResetItemClick.bind(this)}
        >
          <span>{'Reset to default'}</span>
        </div>

        {jobTableDefinition.map(column => (
          <div
            className="table-columns-drop-down-item"
            key={column.key}
            onClick={this.handleItemClick.bind(this, column)}
          >
            <Checkbubble
              checked={column.visible}
              size={CHECKBUBLE_SIZE_SMALL}
              onClick={this.handleCheckboxClick.bind(this)}
            />
            <span>{column.name}</span>
          </div>
        ))}
      </HeaderDropDown>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var newState;
  if(state!=undefined){
      newState = state;
  }

 return {
    jobSummaries: state.jobSummaries,
    jobTableDefinition: getDefinitionForWorkflow(state,ownProps.params),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(userColumnVisibilitiesActions, dispatch),
  };
}

// Connect without withRouter
export default connect(mapStateToProps, mapDispatchToProps)(TableColumnsDropDown);
